export const educationData = [
    {
        id: 1,
        institution: 'AUC - Ethiopia',
        course: 'BSc. Management',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 2,
        institution: 'ACT - American College of Technology',
        course: 'Bachelor of Technology',
        startYear: '2023',
        endYear: 'Present'
    },
    {
        id: 3,
        institution: 'Gebeya Talent',
        course: 'API Development',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 4,
        institution: 'Stanford University - Online',
        course: 'Machine Learning  - by Andrew NG.',
        startYear: 'Jul 2022',
        endYear: 'Sep 2022'
    }
]